import { AnimatedValue } from "./components/AnimatedValue";
import { TextContent } from "./components/TextContent";

export interface PreviewContentProps {
  shouldAnimate: boolean;
  shouldShowSkeleton: boolean;
  value: string | undefined;
}

export const ShimmerRow = () => (
  <div className="h-3 w-1/2 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
);

export const PreviewContent = ({
  shouldShowSkeleton,
  value,
  shouldAnimate,
}: PreviewContentProps) =>
  shouldShowSkeleton ? (
    <ShimmerRow />
  ) : (
    <AnimatedValue value={value ?? ""} animate={shouldAnimate}>
      <TextContent content={value ?? ""} />
    </AnimatedValue>
  );
